import React, { useState } from "react";
import { ENCOUNTERS } from "./data.js";

export default function BuildStage({ onComplete }) {
  const [index, setIndex] = useState(0);
  const [resolved, setResolved] = useState(null);
  const [log, setLog] = useState([]);

  const encounter = ENCOUNTERS[index];
  const done = index >= ENCOUNTERS.length;

  const applyChoice = (choice) => {
    setLog((prev) => [...prev, { label: encounter.label, choice }]);
    setResolved(choice);
  };

  const advance = () => {
    setResolved(null);
    if (index + 1 < ENCOUNTERS.length) {
      setIndex((i) => i + 1);
    } else {
      onComplete({ log });
    }
  };

  if (done) return null;

  return (
    <div>
      <div className="mb-4 flex items-center justify-between font-display text-[9px] text-mist/50">
        <span>THE 90-DAY BUILD</span>
        <span>
          {index + 1}/{ENCOUNTERS.length}
        </span>
      </div>

      <div className="animate-popIn mb-5 border-2 border-black bg-ink p-5">
        <p className="mb-2 text-[10px] uppercase text-mist/40">{encounter.phase}</p>
        <p className="pixel-heading mb-3 text-sm text-mist">{encounter.label}</p>
        <p className="text-sm leading-relaxed text-mist/80">{encounter.text}</p>
      </div>

      {!resolved ? (
        <div className="space-y-2">
          {encounter.choices.map((choice) => (
            <button
              key={choice.id}
              onClick={() => applyChoice(choice)}
              className="w-full border-2 border-mist/30 px-4 py-3 text-left text-xs text-mist transition-colors hover:border-cyan hover:text-cyan"
            >
              {choice.label}
            </button>
          ))}
        </div>
      ) : (
        <div
          className={`animate-popIn border-2 p-4 text-center ${
            resolved.tag === "good" ? "border-lime bg-lime/10 text-lime" : "border-danger bg-danger/10 text-danger"
          }`}
        >
          <p className="mb-3 text-xs">{resolved.result}</p>
          <button onClick={advance} className="btn-cyan !text-[9px]">
            CONTINUE ▶
          </button>
        </div>
      )}
    </div>
  );
}
